import React , {useState, useEffect } from 'react';
import propTypes from "prop-types";
import {Card, Row, Col, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

export default function Our_Achivements ({ Our_Achivements }) {
  const [currentIndex, setCurrentIndex ] = useState(0);
  const [visibleCount, setVisibleCount ] = useState(getVisbleCount());

  function getVisbleCount(){
    if(window.innerWidth < 768 ) return 1;
    return 2; 
  }

  useEffect (() => {
    const handleResize = () => {
      setVisibleCount(getVisbleCount());

    }
    window.addEventListener("resize",handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const nextIndex = prevIndex + 1;
        const maxIndex = Our_Achivements.length - visibleCount;
        return nextIndex > maxIndex ? 0 : nextIndex;

      });
    }, 3500 )
    return () => clearInterval(interval);

  }, [Our_Achivements.length, visibleCount]);

  if(!Our_Achivements || Our_Achivements.length === 0 ){
    return (
      <section id='Achivements'>
        <div style={{padding:"20px", textAlign:"center"}}>
          <h3>No Achivements Availabe</h3>
        </div>
      </section>
    );
  }

  const handlePrev = () => {
    setCurrentIndex((prev) => Math.max(prev -1 , 0 ));
  }

  const handleNext = () => {
    setCurrentIndex((prev) => 
    Math.min(prev + 1, Our_Achivements.length- visibleCount)
  );
  }

  const visibleAchievements = Our_Achivements.slice(
    currentIndex,
    currentIndex + visibleCount
  );

  return (
    <section id='Achivements'>
      <h3 className='text-center my-5'>
        Our_Achivements<span className='text-primary'>.</span>
      </h3>
      <div style={{ padding: "20px", textAlign: "center" }}>
        <Row justify="center" gutter={[16,16]} align="middle">
          <Col>
          <Button
          icon={< LeftOutlined />}
          onClick={handlePrev}
          disabled={currentIndex === 0}
          />
            </Col>

            {visibleAchievements.map((achivement, index) => (
              <Col key={index} xs={24} sm={12} md={8} lg={6}>
              <Card 
                hoverable
                style={{width:"100%", maxWidth:"300px", margin:"10px auto"}}
                cover={<img alt={achivement.name} src={achivement.image} />}
                >
                  <h5><b>{achivement.name}</b></h5>
                  <p>{achivement.description}</p>
                </Card>
                </Col>
            ))}
            <Col>
            <Button
            icon={<RightOutlined />}
            onClick={handleNext}
            disabled={currentIndex + visibleCount >= Our_Achivements.length}
            />
            </Col>

        </Row>

      </div>
    </section>
  )

  

}

Our_Achivements.propTypes = {
  Our_Achivements: propTypes.arrayOf(
    propTypes.shape({
      name: propTypes.string.isRequired,
      image: propTypes.string.isRequired,
      description: propTypes.string.isRequired,
    })
  )
};




